import { FC, useEffect, useState } from 'react'
import {
  Control,
  FieldErrors,
  UseFormClearErrors,
  UseFormSetValue,
  UseFormGetValues,
  UseFormHandleSubmit,
} from 'react-hook-form'
import clsx from 'clsx'

import Button from 'components/parts/button/button'
import ControllerPhoneInput from 'components/form-parts/controller-hook-forms/controller-phone-input/controller-phone-input'

import { HOUR } from 'constants/timeslot'
import { FormValues, FieldId } from '../../data'
import { FieldsNameVoc } from 'constants/auth/profile-data'
import { nestApiPath } from 'constants/url'
import { getAxiosSingle } from 'pages/api/axios'
import { RegStep } from '../../data'
import {
  A_openRegAndLogin2,
  A_signinProgress,
  stepRegProgress,
} from 'utils/analytics/other/registration/registration'

import styles from './start-widget.module.scss'
import common from '../../registration-code.module.scss'
import { LocalStorageKeys, SessionStorageKeys } from 'constants/storage'
import useOnboardingCreateConfig from 'hooks/useOnboardingCreateConfig'

interface IStartWidget {
  control: Control<FormValues>
  errors: FieldErrors
  clearErrors: UseFormClearErrors<FormValues>
  getValues: UseFormGetValues<FormValues>
  setValue: UseFormSetValue<FormValues>
  setStep: React.Dispatch<React.SetStateAction<RegStep>>
  handleSubmit: UseFormHandleSubmit<FormValues>
}

const StartWidget: FC<IStartWidget> = ({
  control,
  errors,
  setStep,
  setValue,
  getValues,
  handleSubmit,
  clearErrors,
}) => {
  const [isSending, setSending] = useState(false)
  const isButtonDisabled = isSending || Boolean(errors[FieldsNameVoc.phone])
  const { config } = useOnboardingCreateConfig()

  const gg = () => {
    localStorage.setItem(LocalStorageKeys.PUSH_WEEKLY_CHECK, String(new Date().getTime() + HOUR))
    sessionStorage.setItem(SessionStorageKeys.FIRST_TIME, 'true')
    sessionStorage.setItem(SessionStorageKeys.SUCCESS_REGISTRAION, 'true')
    sessionStorage.setItem(SessionStorageKeys.ONBOARDING_STATUS, JSON.stringify(config))
    console.log('etheth')
  }
  const enterHandler = async () => {
    const currValues = getValues()
    const phone = currValues[FieldsNameVoc.phone]?.replace(/\D/g, '')
    const isRussia = currValues[FieldsNameVoc.countryCode] === 'RU'
    if (phone && isRussia) {
      setSending(true)
      const userData = await getAxiosSingle(`${nestApiPath}/user/checkphone?phone=+${phone}`)

      if (userData?.status === 409) {
        setStep(RegStep.ERROR)
        return
      }

      if (userData?.isExists === true) {
        setStep(RegStep.PHONE_FLOW_OK)
        setValue(FieldId, userData.id)
        setValue(FieldsNameVoc.email, userData.email)
        return
      }
      if (userData?.isExists === false) {
        setStep(RegStep.PHONE_FLOW_NOREG)
        return
      }
    }

    if (phone && !isRussia) {
      setSending(true)
      const userData = await getAxiosSingle(`${nestApiPath}/user/checkphone?phone=+${phone}`)

      if (userData?.response?.status === 409) {
        setStep(RegStep.ERROR)
        return
      }
      A_signinProgress(stepRegProgress.FOREIGN)

      if (userData?.isExists === true) {
        setStep(RegStep.EMAIL_WIDGET)
        return
      }
      if (userData?.isExists === false) {
        setStep(RegStep.EMAIL_WIDGET)
        return
      }

      setStep(RegStep.ERROR)
      setSending(false)
    }
  }

  const handleKeyPress = (e: React.KeyboardEvent<HTMLFormElement>) => {
    if (e.key === 'Enter' && !isSending) {
      handleSubmit(enterHandler)
    }
  }
  useEffect(() => {
    A_openRegAndLogin2()
  }, [])

  return (
    <div className={common.wrapperCommon}>
      <div className={common.title}>Введите номер телефона</div>
      <div className={clsx(common.subtitle, styles.subtitle)} onClick={gg}>
        Вам поступит звонок с незнакомого номера. Отвечать не нужно.
      </div>
      <form id="form" onSubmit={handleSubmit(enterHandler)} onKeyDown={handleKeyPress}>
        <div className={common.inputWrap}>
          <ControllerPhoneInput
            control={control}
            errors={errors}
            noErrorOnTouch={clearErrors}
            setValue={setValue}
            noName
          />
        </div>
        <div>
          <Button type="submit" disabled={isButtonDisabled}>
            {isSending ? 'Отправка...' : 'Войти в аккаунт'}
          </Button>
        </div>
      </form>
    </div>
  )
}

export default StartWidget
